// angular
import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import { ButtonComponent } from '@app/core/components/button/button.component';
// types
import { AlertType } from '@app/+chat/shared/types/alert.type';

@Component({
  selector: 'pwj-alert-box',
  standalone: true,
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './alert-box.component.html',
  styleUrl: './alert-box.component.scss',
})
export class AlertBoxComponent {
  // inputs
  alertMode = input<'question' | 'towRoute' | 'oneRoute'>('question');
  alertData = input.required<AlertType>();
  alertMessage = input.required<string>();
  messagePreIcon = input<string>();
  // outputs
  getResult = output<string | boolean>();

  public onSelectOption(option: string | boolean) {
    this.getResult.emit(option);
  }
}
